import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination } from 'swiper/modules';
export default class CtaBlocks {
    constructor() {
        this.sections = document.querySelectorAll('.components-block-cta-blocks');

        this.ready();
    }

    ready() {
        this.sections.forEach((section) => {
            this.section = section;
            this.slider = this.section.querySelector('.swiper');
            this.navigationPrev = this.section.querySelector('.slider-button-prev');
            this.navigationNext = this.section.querySelector('.slider-button-next');
            this.pagination = this.section.querySelector('.swiper-pagination-nav');

            if (this.section.firstElementChild.classList.contains('center')) {
                const swiper = new Swiper(this.slider, {
                    modules: [Navigation, Pagination],
                    grabCursor: true,
                    slidesPerView: 3,
                    spaceBetween: '56px',
                    allowTouchMove: true,
                    navigation: {
                        nextEl: this.navigationNext,
                        prevEl: this.navigationPrev,
                    },
                    breakpoints: {
                        0: {
                            slidesPerView: 1,
                            pagination: {
                                el: this.pagination,
                                type: 'fraction',
                            },
                        },
                        1024: {
                            slidesPerView: 3,
                            pagination: '',
                        },
                    },
                });
            }
        });
    }
}

if (document.querySelectorAll('.components-block-cta-blocks').length > 0) {
    new CtaBlocks();
}
